import React from "react";
import { FileUploadCompleteProps } from "./types";
import { Box, IconButton, Stack, Text } from "@origin-digital/ods-core";
import { IconClose } from "@origin-digital/ods-icons";
import { IconButtonColor } from "@origin-digital/ods-types/.";

export const FileUploadComplete: React.FC<FileUploadCompleteProps> = ({
  file,
  handleRemoveFile,
}) => {
  return (
    <Box display="flex" alignItems="flex-start">
      <Stack space="xxsmall">
        {/* <Text weight="medium">{file.fileType}</Text> */}
        <Box display="flex" alignItems="center">
          <Text wordBreak data-role="value">
            {file.name}
          </Text>
        </Box>
      </Stack>
      <Box display="inline-flex" marginLeft="xsmall">
        <IconButton
          noIconPadding
          aria-label="Remove file"
          color={"grey300" as IconButtonColor}
          onClick={() => handleRemoveFile(file.attachmentId)}
        >
          <IconClose size="xsmall" />
        </IconButton>
      </Box>
    </Box>
  );
};
